export const loadonMapPoc = (
  routeGeoJson,
  index,
  setSelectedRoutePath,
  map,
  setSelectedRoute,
  markers,
  turf
) => {
  setSelectedRoutePath(index);
  let start = `${markers[0].lng},${markers[0].lat}`;
  let end = `${markers[markers.length - 1].lng},${markers[markers.length - 1].lat}`;

  let obj = {
    start,
    end,
    geoJSON: routeGeoJson,
    distance: turf.length(routeGeoJson, { units: 'meters' }).toFixed(3),
  };
  setSelectedRoute(obj);
  if (map.current.getLayer('selected-route')) {
    map.current.removeLayer('selected-route');
    map.current.removeSource('selected-route');
  }

  // Add route source
  map.current.addSource(`selected-route`, {
    type: 'geojson',
    data: {
      type: 'Feature',
      geometry: routeGeoJson,
    },
  });

  // // Add route layer for each alternate route with profile-specific color
  map.current.addLayer({
    id: `selected-route`,
    type: 'line',
    source: `selected-route`,
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    paint: {
      'line-color': '#3887be', // Different color for each profile and route
      'line-width': 6,
      'line-opacity': 0.7,
    },
  });
};
